import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step5 } from '../../../../shared/models/component-messages/diveIN/step5';
import { CTRL_411_def } from '../../../validators/411/ctrl411_def';
import { CTRL_419 } from '../../../validators/419/ctrl419';
import { CTRL_430 } from '../../../validators/430/ctrl430';
import { CTRL_432 } from '../../../validators/432/ctrl432';
import { CTRL_621 } from '../../../validators/621/ctrl621';
import { CTRL_72 } from '../../../validators/72/ctrl72';
import { CTRL_73 } from '../../../validators/73/ctrl73';
import { TypeDelaisDivers } from '../models/TypeDelaisDivers';
import { DivINControlNames } from '../services/DivINControleNames';

@Component({
  selector: 'app-type-delais-divers',
  templateUrl: './type-delais-divers.component.html'
})
export class TypeDelaisDiversComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeDelaisDivers';
  @Input() parentForm: FormGroup;
  @Input() delais: TypeDelaisDivers;
  @Input() disabled: boolean;

  public step5 = new Step5();

  public rg3 = CTRL_432.id + '_3';
  public rg6 = CTRL_411_def.id + '_1';
  public rg7 = CTRL_73.id + '_1';
  public rg9 = CTRL_72.id + '_1';
  public rg10 = CTRL_419.id + '_1';
  public rg11 = CTRL_621.id + '_1';

  constructor() {
  }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: DivINControlNames.getCtrl_432Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg6, new FormControl({ rgCtrls: DivINControlNames.getCtrl_411Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg7, new FormControl({ rgCtrls: DivINControlNames.getCtrl_73Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg9, new FormControl({ rgCtrls: DivINControlNames.getCtrl_72Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg10, new FormControl({ rgCtrls: DivINControlNames.getCtrl_432Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg11, new FormControl({ rgCtrls: DivINControlNames.getCtrl_432Names_json() }));
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }
}

